module.exports = __webpack_public_path__ + "static/img/gt-icon.810c4bbf.gif";